<script>
import { getDatetimeFormattedString } from "@/helpers";
import api from "@/api";

export default {
  props: ["dateFormat", "domain", "taskList", "timeFormat", "timezone"],
  data() {
    return {
      pollers: undefined,
      error: undefined,
      loading: true,
    };
  },
  computed: {
    formattedPollers() {
      const { dateFormat, pollers, timeFormat, timezone } = this;

      return (
        pollers &&
        pollers.map((poller) => ({
          ...poller,
          lastAccessTime: getDatetimeFormattedString({
            date: poller.lastAccessTime,
            dateFormat,
            timeFormat,
            timezone,
          }),
        }))
      );
    },
  },

  created() {
    this.getPollers();
  },
  methods: {
    async getPollers() {
      const res = await api.getPollersInDomainByName(
        this.domain,
        this.taskList
      );
      this.loading = false;
      if (res.data.status === 200 && res.data.response) {
        const p = res.data.response;
        this.pollers = Object.keys(p).map((identity) => ({
          identity,
          lastAccessTime: p[identity].lastAccessTime,
          handlesDecisions: p[identity].taskListTypes.includes("decision"),
          handlesActivities: p[identity].taskListTypes.includes("activity"),
        }));
      } else {
        this.error = `查询${this.taskListName}任务pollers信息失败`;
      }
    },
  },
};
</script>

<template>
  <section :class="{ 'task-list-pollers': true, loading }">
    <table v-if="pollers">
      <thead>
        <th>Id</th>
        <th>{{ $t("dj-最后访问时间") }}</th>
        <th>Decision{{ $t("dj-处理结果") }}</th>
        <th>Activity{{ $t("dj-处理结果") }}</th>
      </thead>
      <tbody>
        <tr v-for="p in formattedPollers" :key="p.identity">
          <td>{{ p.identity }}</td>
          <td>{{ p.lastAccessTime }}</td>
          <td class="decision" :data-handled="p.handlesDecisions"></td>
          <td class="activity" :data-handled="p.handlesActivities"></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<style lang="stylus">
@require '../../styles/definitions.styl';

section.task-list-pollers {
  > header {
    padding: inline-spacing-medium;
  }

  table {
    max-width: 1600px;
  }

  td:nth-child(3), td:nth-child(4) {
    width: 230px;
  }

  td[data-handled='true'] {
    padding-left: 75px;
    icon-check();
  }
}
</style>
